'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkButton = undefined;
var _jsxFileName = 'src/index.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
exports.ButtonGroup = ButtonGroup;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _reactRouterDom = require('react-router-dom');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _glamor = require('glamor');
var _themes = require('@marmalade/themes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var buttonTheme = _themes.componentThemes.button.buttonTheme;

// This adds a plugin that causes glamor's css selectors to use a body id.
// This gives them greater specificity, so they win over things like normalize.

_glamor.plugins.add((0, _themes.getSpecificityPlugin)());

// This is the actual css of the button, it uses the theme to allow for greater customization.
var buttonStyles = function buttonStyles(props) {
  var theme = buttonTheme(props.theme);
  var disabled = props.disabled,
    size = props.size,
    block = props.block,
    prominence = props.prominence;
  var selected = prominence === 'selected';
  var hoverStyles = function hoverStyles() {
    if (!(disabled || selected)) {
      return {
        boxShadow: theme[fetchProminenceVariant('Button_boxShadow_hover')],
        borderColor: theme[fetchProminenceVariant('Button_borderColor_hover')],
        backgroundImage: theme.Button_backgroundImage_hover,
        textDecoration: 'none',
        backgroundColor: theme[fetchProminenceVariant('Button_backgroundColor_hover')],
        color: theme[fetchProminenceVariant('Button_color_hover')]
      };
    }
    return {};
  };
  var nonDefaultSize = function nonDefaultSize() {
    switch (size) {
      case 'sm':
        return {
          padding: '.25rem 1rem',
          minHeight: '3rem',
          fontSize: '1.6rem'
        };
      case 'lg':
        return {
          padding: '1.5rem 3rem',
          fontSize: '1.8rem'
        };
      case 'xl':
        return {
          padding: '2.4rem 2.8rem',
          fontSize: '1.8rem'
        };
      default:
        return {};
    }
  };
  var blockStyles = _defineProperty({
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '100%',
    maxWidth: '375px',
    textAlign: 'center',
    display: 'block'
  }, (0, _themes.atLeast)(theme.breakpoint_md), {
    maxWidth: '300px'
  });

  // Fetches a theme prop including prominence if available
  var fetchProminenceVariant = function fetchProminenceVariant(style) {
    var type = selected ? 'selected' : prominence;
    if (type === 'default') {
      return style;
    }
    var newStyle = (0, _themes.addVariant)(style, type);
    if (Object.prototype.hasOwnProperty.call(theme, newStyle)) {
      return newStyle;
    }
    return style;
  };
  return Object.assign({
    textDecoration: 'none',
    cursor: disabled ? 'not-allowed' : 'pointer',
    display: 'inline-block',
    transitionProperty: 'background-color, background-image, border-color',
    transitionDuration: '.3s',
    transitionTimingFunction: 'ease-in-out',
    borderRadius: theme.Button_borderRadius,
    borderWidth: theme.Button_borderWidth,
    borderStyle: theme.Button_borderStyle,
    borderColor: theme[fetchProminenceVariant('Button_borderColor')],
    backgroundColor: theme[fetchProminenceVariant('Button_backgroundColor')],
    backgroundImage: theme[fetchProminenceVariant('Button_backgroundImage')],
    boxShadow: theme[fetchProminenceVariant('Button_boxShadow')],
    padding: '.6rem 2rem',
    whiteSpace: 'nowrap',
    lineHeight: '3.1rem',
    minHeight: '4.5rem',
    marginBottom: '.5rem',
    fontWeight: theme.Button_fontWeight,
    fontFamily: 'inherit',
    color: theme[fetchProminenceVariant('Button_color')],
    opacity: disabled ? '.5' : '1',
    ':hover': hoverStyles()
  }, size !== 'default' ? nonDefaultSize() : {}, block ? blockStyles : {});
};

// This stops warnings for props in console.
var filterProps = {
  filterProps: ['icon', 'block', 'posting']
};
var Button = function (_Component) {
  _inherits(Button, _Component);
  function Button() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, Button);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      Button: (0, _glamorous2.default)(_this.props.Element, filterProps)(buttonStyles)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(Button, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        Element = _props.Element,
        children = _props.children,
        text = _props.text,
        disabled = _props.disabled,
        posting = _props.posting,
        htmlFor = _props.htmlFor,
        onClick = _props.onClick,
        submit = _props.submit,
        prominence = _props.prominence,
        selected = _props.selected,
        rest = _objectWithoutProperties(_props, ['Element', 'children', 'text', 'disabled', 'posting', 'htmlFor', 'onClick', 'submit', 'prominence', 'selected']);
      var type = submit ? 'submit' : 'button';
      return _react2.default.createElement(this.state.Button, Object.assign({
        disabled: posting || disabled || undefined,
        htmlFor: Element === 'label' ? htmlFor : undefined,
        onClick: onClick,
        type: Element === 'label' || Element === 'a' ? undefined : type,
        prominence: selected ? 'selected' : prominence
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 185
        },
        __self: this
      }), posting ? _react2.default.createElement('span', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 193
        },
        __self: this
      }, 'Loading...') : text || children);
    }
  }]);
  return Button;
}(_react.Component);
Button.propTypes = {
  /** Block buttons will fill the width of their container and sit on top of one another. */
  block: _propTypes.bool,
  children: _propTypes.node,
  /** Disabled buttons cannot be clicked and visually apear more dim. */
  disabled: _propTypes.bool,
  /** Pick the HTML element the button will render as. */
  Element: (0, _propTypes.oneOf)(['button', 'label', 'a']),
  /** For buttons of link elements, define the link that they will navigate to on click. */
  href: _propTypes.string,
  /** Set the HTML For attribute of the rendered element. */
  htmlFor: _propTypes.string,
  /** Optionally use an icon with the button */
  icon: _propTypes.bool,
  /** Handle to button click event. */
  onClick: _propTypes.func,
  /** TODO: Document what this prop does. */
  posting: _propTypes.bool,
  /** Set the prominence of the button */
  prominence: (0, _propTypes.oneOf)(['default', 'warning', 'danger', 'primary', 'secondary', 'tertiary']),
  /** For use as a radio replacement, set the selected state to true to make the button appear selected. */
  selected: _propTypes.bool,
  /** Define the size of the button. */
  size: (0, _propTypes.oneOf)(['default', 'lg', 'sm', 'xl']),
  /** Allow the button to submit a form. */
  submit: _propTypes.bool,
  /** Define the text content of the button without passing a text node as a child. */
  text: _propTypes.string,
  className: _propTypes.string
};
Button.defaultProps = {
  block: false,
  children: undefined,
  disabled: false,
  Element: 'button',
  href: undefined,
  htmlFor: undefined,
  icon: false,
  onClick: undefined,
  posting: false,
  prominence: 'default',
  selected: false,
  size: 'default',
  submit: false,
  text: undefined,
  className: undefined
};
exports.default = Button;
var LinkButton = exports.LinkButton = (0, _glamorous2.default)(_reactRouterDom.Link, filterProps)(buttonStyles);
ButtonGroup.propTypes = {
  children: _propTypes.node.isRequired,
  stacked: _propTypes.bool
};
ButtonGroup.defaultProps = {
  stacked: false
};
function ButtonGroup(props) {
  return _react2.default.createElement(_glamorous2.default.Div, {
    css: !props.stacked ? {
      '> :not(:last-child)': {
        marginRight: '.25em'
      }
    } : {},
    __source: {
      fileName: _jsxFileName,
      lineNumber: 212
    },
    __self: this
  }, props.children);
}